import { create } from 'zustand';

export interface CaptchaSlice {
  // States
  isShowCaptcha: boolean;
  // Actions
  showCaptcha: () => void;
  hideCaptcha: () => void;
  resetCaptcha: () => void;
}

export const useCaptchaStore = create<CaptchaSlice>()((set) => {
  return {
    isShowCaptcha: false,
    showCaptcha: () => set({ isShowCaptcha: true }),
    hideCaptcha: () => set({ isShowCaptcha: false }),
    resetCaptcha: () => window.grecaptcha.reset(),
  };
});
